// extracted by mini-css-extract-plugin
export default {"btop":"_0cb3221f76 _5438ceafb1 _84a28dd619","icon":"_66b91f65d0 _963f8c2d19","btoppink":"_66c4c8bdd9 _05b6ea09da"};